export default __webpack_public_path__ + "static/media/Inter-Thin.de9194d1.woff2";